import * as React from "react";
import { Select } from "antd";
import { SizeType } from "antd/lib/config-provider/SizeContext";
import { DateService } from "../../service/DateService";

declare module "antd/lib/select" {
  export interface OptionProps {
    label?: React.ReactNode;
  }
}

const { Option } = Select;
export interface State {}

export interface Props {
  onChange?: any;
  onSearch?: any;
  onSelect?: any;
  onFocus?: any;
  placeholder?: string | React.ReactNode;
  value?: string | number | any;
  allowClear?: boolean;
  showSearch?: boolean;
  notFoundContent?: string;
  key?: any;
  style?: React.CSSProperties;
  loading?: boolean;
  optionFilterProp?: string;
  selectOptions: any;
  selectOptionKey: any;
  selectOptionValue: any;
  clearIcon?: any;
  defaultActiveFirstOption?: boolean;
  defaultValue?: string | number | any;
  disabled?: boolean;
  mode?: any;
  size?: SizeType;
  onDeselect?: any;
  labelTypeDate?: boolean;
  otherData?: string[];
  className?: any;
}
export interface OptionProps {
  disabled?: boolean;
  value?: string | number;
  title?: string;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  label?: string | number;
}

export default class SelectInput extends React.Component<Props, State> {
  static Option: React.ClassicComponentClass<OptionProps>;
  render() {
    const {
      showSearch,
      onChange,
      onSearch,
      onSelect,
      onFocus,
      placeholder,
      allowClear,
      notFoundContent,
      style,
      loading,
      optionFilterProp = "label",
      selectOptionKey,
      selectOptionValue,
      selectOptions,
      clearIcon,
      value,
      defaultActiveFirstOption,
      disabled,
      defaultValue,
      mode,
      size,
      onDeselect,
      labelTypeDate,
      otherData,
      className
    } = this.props;

    return (
      <Select
        defaultValue={defaultValue}
        onSearch={onSearch}
        onSelect={onSelect}
        onFocus={onFocus}
        placeholder={placeholder}
        value={value}
        allowClear={allowClear}
        notFoundContent={notFoundContent}
        style={style}
        loading={loading}
        optionFilterProp={optionFilterProp}
        showSearch={showSearch}
        onChange={onChange}
        clearIcon={clearIcon}
        defaultActiveFirstOption={defaultActiveFirstOption}
        disabled={disabled}
        mode={mode}
        size={size}
        onDeselect={onDeselect}
        className={className}
      >
        {labelTypeDate
          ? selectOptions?.map((item) => (
              <Option
                key={item[selectOptionKey]}
                value={item[selectOptionKey]}
                title={item[selectOptionValue]}
                disabled={item.disabled || false}
                label={DateService().formatToLocalTime(item[selectOptionValue])}
              >
                {DateService().formatToLocalTime(item[selectOptionValue])}
              </Option>
            ))
          : selectOptions?.map((item) => (
              <Option
                key={item[selectOptionKey]}
                value={item[selectOptionKey]}
                title={item[selectOptionValue]}
                label={item[selectOptionValue]}
                disabled={item.disabled || false}
                otherData={otherData && otherData.map((e) => item[e])}
              >
                {item[selectOptionValue]}
              </Option>
            ))}
      </Select>
    );
  }
}
